<div class="action-co-body">
  <div class="row col-12 mt-0 mb-2">

    <ng-container *ngIf="mode === 'DEVIS'">
      <div>
        <select class="q-main-select" (change)="OnDevisBoChange($event.target.value)">
          <option *ngFor="let devis of listValue" [value]="devis.id" [selected]="devis.id == idDonneeFils">{{devis.value}}</option>
        </select>
      </div>
    </ng-container>

    <ng-container *ngIf="mode === 'CUSTOMER'">
      <div>
        <select class="q-main-select" (change)="OnCustomerBoChange($event.target.value)">
          <option value="Prospect">Prospect</option>
          <option value="Customer">Client</option>
        </select>
      </div>
    </ng-container>

    <ng-container *ngIf="mode == 'INDIVIDUEL'">
      <div class="d-flex">
        <!-- (change)="OnCustomerBoChange($event.target.value)" -->
        <p class="mr-2">Créer en tant que</p>
        <select class="q-main-select" (change)="ChangeCustomerType($event.target.value)"> 
          <option value="Prospect">Prospect</option>
          <option value="Customer">Client</option>
        </select>
      </div>
    </ng-container>

    <ng-container *ngIf="mode === 'CONTACT'">
      <div class="q-check">
        <input type="checkbox" id="check" [ngModel]="isMainContact" (ngModelChange)="OnMainContactChange($event)" />
        <label for="check">
          <span></span>Créer en contact principal
        </label>
      </div>
    </ng-container>

    <div class="col-auto ml-auto">
      <button (click)="OnCancel()" title="Annuler l'édition" class="btn-icon">
        <i Class="fas fa-undo q-c-danger q-pointer"></i>
      </button>
    </div>
  </div>

  <q-bodisplay *ngIf="!isReloading" class="w-100 h-100 mb-5" [item]="BoModel" (sendBoReady)="BoReady($event)" (sendEvent)="OnSaveBo($event)"></q-bodisplay>

</div>
